import { Injectable } from '@angular/core';
import { AbstractImageService } from 'projects/game-utils/src/lib/service/abstract.image.service';

@Injectable({
  providedIn: 'root'
})
export class ImageService extends AbstractImageService{

  constructor() { 
    super();
  }
}
